import { gql } from '@apollo/client';

export const GET_CSVFILE_ALL_COLUMNS = gql`
  query GetCSVFileAllColumns($input: CSVFileInput!) {
    columns: getCSVFileAllColumns(input: $input) {
      id
      index
      name
    }
  }
`;
